import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Formik } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import dayjs from 'dayjs';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { commonReducerAction } from 'src/redux/reducers/common';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import BatchForm from 'src/components/batches/BatchForm';
import { batchesReducerAction } from 'src/redux/reducers/batches';
import { getBatch, updateBatch } from 'src/api/batches';

const UpdateBatch = () => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user ,gymId} = useSelector((state) => state.common);
  const { updatebatch } = batchesReducerAction;
  const { logoutUser } = commonReducerAction;
  const { batchList } = useSelector((state) => state.batches);

  const [batch, setBatch] = useState({
    name: '',
    start_time: null,
    end_time: null
  });

  const location = useLocation();
  const _id = location?.pathname?.split('/')?.pop();

  useEffect(() => {
    if (batchList?.length) {
      const batch = batchList.find((batch) => batch?._id === _id);
      if (batch) {
        setBatch(batch);
      }
    } else {
      dispatch(startLoading());
      getBatch(user , gymId)
        .then((res) => {
          if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
            dispatch(logoutUser());
          if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
            dispatch(updatebatch(res.data));
          }
          dispatch(stopLoading());
        })
        .catch((err) => {
          console.log(err);
          dispatch(stopLoading());
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchList]);

  const navigate = useNavigate();
  const date = dayjs().format('YYYY-MM-DD');

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>Batch | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              name: batch?.name,
              start_time: dayjs(batch?.start_time).format('hh:mm'),
              end_time: dayjs(batch?.end_time).format('hh:mm')
            }}
            enableReinitialize
            validationSchema={CONSTANTS.batchValidationSchema}
            onSubmit={async (values) => {
              values.start_time = dayjs(date + values.start_time).valueOf();
              values.end_time = dayjs(date + values.end_time).valueOf();
              values.gym_id = gymId
              try {
                dispatch(startLoading());
                const res = await updateBatch(user, values, batch?._id);
                dispatch(stopLoading());

                const isError = res.status !== 200;
                const message = isError ? res?.message : "Batch Updated Successfully"
                setSnackbarState({
                  open: true,
                  message: message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.BATCHES);
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <BatchForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.UPDATE_BATCH}
                isFromUpdateBatch={true}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default UpdateBatch;
